(function () {
  'use strict';

  angular
    .module('reprodRotasModule', []);
}());
